import React from 'react';

function Desktop({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="3" y="5" width="18" height="12" rx="2" />
      <path d="M8 17H16V18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18V17Z" />
    </svg>
  );
}

export default Desktop;
